import classNames from "classnames";
import { camelCase } from "lodash";
import React, { useContext } from "react";
import { ContentTraverserContext, RicosContext, RicosViewerContext } from "./../../../../../ricos-context";
import { ErrorBoundary } from "../../../components/ErrorBoundary";
import Anchorable from "../../utils/Anchorable";
import { ContainerElement } from "./ContainerElement";
import { alignmentClassName, sizeClassName, textWrapClassName } from "./getClassNames";
import styles from "./plugin.rtlignore-scss";
const isDefined = (value) => value !== void 0;
const convertSpoilerData = (data) => {
  return {
    config: {
      spoiler: {
        enabled: !!data.spoiler?.enabled,
        description: data.spoiler?.description,
        buttonContent: data.spoiler?.buttonContent
      }
    }
  };
};
const nodeViewContainer = ({
  node,
  nodeIndex,
  customClassNames,
  withHorizontalScroll,
  children
}) => {
  const { seoMode, anchorTarget, helpers } = useContext(RicosViewerContext);
  const { isMobile } = useContext(RicosContext);
  const { SpoilerViewerWrapper } = useContext(ContentTraverserContext);
  const dataProperty = `${camelCase(node.type)}Data`;
  const { link, containerData } = node[dataProperty] || {};
  const spoilerProps = {
    type: node.type,
    componentData: convertSpoilerData(node[dataProperty].containerData || {}),
    helpers,
    children
  };
  const { alignment, size, textWrap } = customClassNames || {};
  const containerClassName = classNames(
    styles.pluginContainerReadOnly,
    {
      [styles.pluginContainerMobile]: isMobile,
      [styles.anchor]: !!link,
      [styles.horizontalScrollbar]: withHorizontalScroll
    },
    isDefined(alignment) ? alignment : alignmentClassName(node),
    isDefined(size) ? size : sizeClassName(node),
    isDefined(textWrap) ? textWrap : textWrapClassName(node)
  );
  let ContainerComponent = /* @__PURE__ */ React.createElement(
    ContainerElement,
    {
      className: containerClassName,
      node,
      nodeIndex,
      context: { seoMode, anchorTarget, isMobile }
    },
    children
  );
  if (SpoilerViewerWrapper) {
    ContainerComponent = /* @__PURE__ */ React.createElement(
      SpoilerViewerWrapper,
      {
        className: containerClassName,
        width: containerData?.width?.custom ? parseInt(containerData.width.custom) : void 0,
        ...spoilerProps
      },
      ContainerComponent
    );
  }
  return /* @__PURE__ */ React.createElement(ErrorBoundary, null, /* @__PURE__ */ React.createElement(Anchorable, { nodeId: node.id }, /* @__PURE__ */ React.createElement("div", { className: styles.atomic }, ContainerComponent)));
};
export {
  nodeViewContainer
};
//# sourceMappingURL=nodeViewContainer.js.map
